import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import styles from './styles.styl';

import { selectDefaultTabId } from '../../../redux/ui/selectors';
import { actions as defaultTab } from '../../../redux/ui/defaultTab';
import {
  selectScheduledTasks,
  selectScheduledTasksCount,
  selectScheduledTasksPending,
  selectScheduledCompletedTasks,
  selectScheduledCompletedTasksCount,
  selectScheduledCompletedTasksPending,
} from '../../../redux/healthboard/selectors';
import { actions as scheduledTasksActions } from '../../../redux/healthboard/requests/scheduled-tasks-upcoming-req';
import { actions as completedTasksActions } from '../../../redux/healthboard/requests/scheduled-tasks-completed-req';

const mapStateToProps = state => ({
  scheduleTasks: selectScheduledTasks(state),
  scheduleTasksPending: selectScheduledTasksPending(state),
  scheduleTasksCount: selectScheduledTasksCount(state),

  completedTasks: selectScheduledCompletedTasks(state),
  completedTasksPending: selectScheduledCompletedTasksPending(state),
  completedTasksCount: selectScheduledCompletedTasksCount(state),
  defaultTab: selectDefaultTabId(state),
});
const mapDispatchToProps = {
  fetchScheduledTasks: scheduledTasksActions.send,
  loadNextScheduledTasks: scheduledTasksActions.loadMore,

  fetchCompletedTasks: completedTasksActions.send,
  loadNextCompletedTasks: completedTasksActions.loadMore,
  resetTab: defaultTab.reset,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ userId }) => ({
    id: userId,
  })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/TodoListTabs/enhance.js